<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="消息类型：" prop="msg_type">
                <span>{{model.msg_type}}</span>
            </el-form-item>
            <el-form-item label="消息内容：" prop="msg">
                <span>{{model.msg}}</span>
            </el-form-item>
            <el-form-item label="记录时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'recordMsgInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                msg_type: '',
                msg: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/recordmsg/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>